import React from 'react';
import { motion } from 'framer-motion';
import { Target, Users, Award } from 'lucide-react';
const objectives = [{
  icon: Target,
  title: 'Enable HCP Presentation',
  description: 'Empower healthcare professionals to confidently present favorable Tralokinumab data with clarity and conviction'
}, {
  icon: Users,
  title: 'Leverage KOL Advocacy',
  description: 'Harness the credibility of strong key opinion leaders as indirect advocates for Tralo and Leo Pharma'
}, {
  icon: Award,
  title: 'Reward Speaker Vanity',
  description: 'Elevate speaker profiles and expertise, making them feel like recognized masters in their field'
}];
export function StrategicIntent() {
  return <section className="py-24 bg-white" data-id="element-256">
      <div className="max-w-6xl mx-auto px-6" data-id="element-257">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-258">
          <h2 className="font-editorial text-4xl md:text-5xl font-bold text-slate-900 mb-4" data-id="element-259">
            Strategic Intent
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto" data-id="element-260">
            Three objectives driving the Master-Class experience
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-261">
          {objectives.map((obj, index) => <motion.div key={obj.title} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-slate-50 rounded-2xl p-8 border border-slate-200 hover:border-red-200 transition-colors" data-id="element-262">
              <obj.icon className="w-10 h-10 text-red-600 mb-4" strokeWidth={1.5} data-id="element-263" />
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-264">
                {obj.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-265">
                {obj.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}